import api from './api.js'

export const getMyEntitlement = () =>
  api.get('/v1/entitlements/me').then((r) => r.data)

export const createCheckoutSession = (data) =>
  api.post('/v1/payments/checkout-session', data).then((r) => r.data)

export const getBillingHistory = () =>
  api.get('/v1/payments/history').then((r) => r.data)

export const startTrial = (planKey, email) =>
  api.post('/v1/trial/start', { planKey, email }).then((r) => r.data)

export const checkTrialEligibility = () =>
  api.get('/v1/trial/eligibility').then((r) => r.data)
